
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getInvestorApiUrl } from "../../utils/config";
import { ApiRequestParams, handleFetchApi } from "../../utils/api";

// Async thunk for fetching properties
// Assuming fetchpropertylist is an API function that returns property data
export const fetchcalenderProperties = createAsyncThunk(
  "calenderProperties/fetchcalenderProperties",
  async (requiredData, { rejectWithValue }) => {
    let baseUrl = getInvestorApiUrl()
    try {
      const params: ApiRequestParams = {
        endpoint: "properties/calendarProperties",
        baseUrl: getInvestorApiUrl(),
        payload: requiredData,
        method: "POST"
      }
      const response = await handleFetchApi(params)
      // const response = await axios.post(`${baseUrl}/properties/calendarProperties`, requiredData);
      const calenderProperties = response?.data?.data || [];  // if data is null in that case it will provide the empty

      return calenderProperties;
    } catch (error: any) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);
export const fetchcalenderPropertiesByPageNumber = createAsyncThunk(
  "calenderProperties/fetchcalenderPropertiesByPageNumber",
  async (requiredData, { rejectWithValue }) => {
    let baseUrl = getInvestorApiUrl()
    try {
      const params: ApiRequestParams = {
        endpoint: "properties/calendarProperties",
        baseUrl: getInvestorApiUrl(),
        payload: requiredData,
        method: "POST"
      }
      const response = await handleFetchApi(params)
      // const response = await axios.post(`${baseUrl}/properties/calendarProperties`, requiredData);
      const calenderProperties = response?.data?.data || [];  // if data is null in that case it will provide the empty

      return calenderProperties;
    } catch (error: any) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);





const calenderPropertySlice = createSlice({
  name: 'properties',
  initialState: {
    calenderProperties: [],
    loading: false,
    error: null,
    fetchLoading: false,
    filterLoading: false,
    propertiesFilters: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchcalenderProperties.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchcalenderProperties.fulfilled, (state, action) => {
        state.loading = false;
        // @ts-ignore
        state.calenderProperties = action.payload; // Store the assets (properties)
      })
      .addCase(fetchcalenderProperties.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload || "Error fetching properties"; // Store the error message
      }).addCase(fetchcalenderPropertiesByPageNumber.pending, (state) => {
        state.fetchLoading = true;
      })
      .addCase(fetchcalenderPropertiesByPageNumber.fulfilled, (state, action) => {
        state.fetchLoading = false;
        // @ts-ignore
        state.calenderProperties = [...state.calenderProperties, ...action.payload]; // Store the assets (properties)
      })
      .addCase(fetchcalenderPropertiesByPageNumber.rejected, (state, action) => {
        state.fetchLoading = false;
        // @ts-ignore
        state.error = action.payload || "Error fetching properties"; // Store the error message
      })
  },
});

export default calenderPropertySlice.reducer;
